'use client';

import { Nullable } from '@/components/types';
import noop from 'lodash/noop';
import React, { createContext, useContext } from 'react';
import type {
  AccountInformation,
  BalanceInformation,
  InstantPayoutFeeData,
} from '../payouts/types/instantPayoutsContext';

export interface InstantPayoutContextProps {
  balanceInformation: BalanceInformation;
  setBalanceInformation: (balanceInformation: BalanceInformation) => void;
  accountInformation: AccountInformation;
  setAccountInformation: (accountInformation: AccountInformation) => void;
  instantPayoutFeeData: Nullable<InstantPayoutFeeData>;
  setInstantPayoutFeeData: (instantPayoutFeeData: Nullable<InstantPayoutFeeData>) => void;
}

const InstantPayoutContext = createContext<InstantPayoutContextProps>({
  balanceInformation: null,
  setBalanceInformation: noop,
  accountInformation: null,
  setAccountInformation: noop,
  instantPayoutFeeData: null,
  setInstantPayoutFeeData: noop,
});

export const InstantPayoutContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [balanceInformation, setBalanceInformation] = React.useState<BalanceInformation>(null);
  const [accountInformation, setAccountInformation] = React.useState<AccountInformation>(null);
  const [instantPayoutFeeData, setInstantPayoutFeeData] =
    React.useState<Nullable<InstantPayoutFeeData>>(null);

  return (
    <InstantPayoutContext.Provider
      value={{
        balanceInformation,
        setBalanceInformation,
        accountInformation,
        setAccountInformation,
        instantPayoutFeeData,
        setInstantPayoutFeeData,
      }}
    >
      {children}
    </InstantPayoutContext.Provider>
  );
};

export const useInstantPayoutContext = () => useContext(InstantPayoutContext);
